var $ = require('jquery');

var Padding = function Padding() {
	var $contentRow = $('.row.-content');
	if($contentRow.next().hasClass('-services')) {
		$contentRow.css('padding-bottom', 0);
	}
}

module.exports = Padding;